import { Link, Button } from '@mui/material';

const SUPPORT_EMAIL = 'support@eon.io';

export function buildMailtoLink(
  email: string,
  options: { subject?: string; body?: string; cc?: string; bcc?: string } = {}
): string {
  const params: string[] = [];

  if (options.subject) {
    params.push(`subject=${encodeURIComponent(options.subject)}`);
  }

  if (options.body) {
    params.push(`body=${encodeURIComponent(options.body)}`);
  }

  if (options.cc) {
    params.push(`cc=${encodeURIComponent(options.cc)}`);
  }

  if (options.bcc) {
    params.push(`bcc=${encodeURIComponent(options.bcc)}`);
  }

  const query = params.length > 0 ? `?${params.join('&')}` : '';
  return `mailto:${email}${query}`;
}

export const ContactSupportButton = ({
  subject,
  body,
}: {
  subject?: string;
  body?: string;
}) => {
  const href = buildMailtoLink(SUPPORT_EMAIL, { subject, body });

  return (
    <Link href={href} underline='always'>
      <Button variant='outlined'>Contact Support</Button>
    </Link>
  );
};

export const ContactSupportLink = () => {
  return (
    <Link
      color='error'
      href={buildMailtoLink(SUPPORT_EMAIL)}
      underline='always'
    >
      email Eon support
    </Link>
  );
};
